<template>
  <v-avatar
    v-bind="$attrs"
    v-on="$listeners"
    :class="{ avatar: true, 'avatar--initials': !profile.profile_image }"
  >
    <v-img
      v-if="profile.profile_image"
      alt="Avatar"
      :src="profile.profile_image"
      contain
    ></v-img>
    <span v-else class="avatar__span">{{
      profile.name | reduceToInitials
    }}</span>
  </v-avatar>
</template>

<script>
export default {
  props: {
    profile: {
      required: true,
      type: Object,
    },
  },

  inheritAttrs: false,
};
</script>

<style scoped>
.avatar--initials {
  background: #add8e6;
}

.avatar--initials .avatar__span {
  color: #333333;
  font-weight: 700;
  font-size: 1rem;
}
</style>
